import { useEffect, useRef, useState } from "react";

const useInputEffect = <TValue, TValueChangeEvent, TValueChangeArg = void>(
  // default/starting value for this input
  defaultValue: TValue,
  // function which is called if the value effectively CHANGED (differs from the previous value), implement e.g. for dispatching
  valueChangeEffectFunction: (changedValue: TValue) => void,
  // function which is called on input element changed event, has to set a value via the returned value setter
  valueChangeHandlerFunction: (event: TValueChangeEvent, arg?: TValueChangeArg | null) => void
) => {
  const [effectHandledValue, setEffectHandledValue] = useState(defaultValue);
  const [value, setValue] = useState(defaultValue);

  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      if (value !== effectHandledValue) {
        valueChangeEffectFunction(value);
        setEffectHandledValue(value);
      }
    } else {
      didMount.current = true;
    }
  }, [effectHandledValue, value, valueChangeEffectFunction]);

  const valueChangeHandler = (event: TValueChangeEvent, arg?: TValueChangeArg | null) => {
    valueChangeHandlerFunction(event, arg);
  };

  return {
    // current input value
    value,
    // reference to input element changed event handler function
    valueChangeHandler,
    // reference to value setter
    setValue,
  };
};

export default useInputEffect;
